import { QueryClient } from '@tanstack/react-query'

/**
 * 5-minute staleTime matches the Flutter app's manual cache TTL.
 * gcTime (formerly cacheTime) is 10 minutes — TanStack default doubled is too aggressive.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      retry: (failureCount, error) => {
        // Don't retry on 401/403/404 — re-auth or genuinely missing.
        const status = (error as { status?: number })?.status
        if (status === 401 || status === 403 || status === 404) return false
        return failureCount < 2
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
})
